import React from 'react';
import styled from 'styled-components';
import { layout } from 'styles/layout';
import { BaseConfetti } from 'elements/confetti/confetti.styles';

export const ConfettiContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  top: 0;
  left: 0;
  overflow: hidden;
`

export const ConfettiElement1 = styled(BaseConfetti).attrs({
  width: 26,
  height: 36,
  viewBox: '0 0 26 36',
  children: <path d="M12.6777 35.3549L25.1831 22.7363L25.1831 12.505L12.6777 5.34058e-05L0.17244 12.505L0.172419 22.7362L12.6777 35.3549Z" fill="#FFDF6E" />
})`
  display: none;

  @media screen and (min-width: ${layout.subLg}) {
    display: block;
    left: 9%;
    top: 7%;
    transform: rotate(-26deg);
  }
`

export const ConfettiElement2 = styled(BaseConfetti).attrs({
  width: 25,
  height: 34,
  viewBox: '0 0 25 34',
  children: <path d="M0.831907 23.5499L24.2607 33.3353L10.6682 -5.57899e-05L0.831907 23.5499Z" fill="#FF7062" />
})`
  display: none;

  @media screen and (min-width: ${layout.subLg}) {
    display: block;
    top: 6%;
    right: 7.5%;
  }
`

export const ConfettiElement3 = styled(BaseConfetti).attrs({
  width: 25,
  height: 34,
  viewBox: '0 0 25 34',
  children: <path d="M0.831907 23.5499L24.2607 33.3353L10.6682 -5.57899e-05L0.831907 23.5499Z" fill="#1cabbf" />
})`
  display: none;

  @media screen and (min-width: ${layout.subLg}) {
    display: block;
    bottom: 34%;
    left: 4.5%;
  }
`

export const ConfettiElement4 = styled(BaseConfetti).attrs({
  width: 429,
  height: 321,
  viewBox: '0 0 429 321',
  children: <>
    <path d="M63.2377 403.501L247.448 393.948L332.539 287.424L291.217 118.097L96.7609 133.188L16.4867 233.682L63.2377 403.501Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M73.9538 390.209L239.986 381.018L317.06 284.531L280.453 131.695L105.168 145.92L32.4568 236.946L73.9538 390.209Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M84.0723 375.868L231.926 367.039L300.983 280.588L269.092 144.244L112.977 157.603L47.8293 239.161L84.0723 375.868Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M96.2034 361.463L225.003 354.095L284.949 279.049L256.814 160.397L120.829 171.689L64.276 242.487L96.2034 361.463Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M107.736 346.009L217.627 339.918L268.645 276.049L244.426 174.889L128.411 184.314L80.2809 244.567L107.736 346.009Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M120.792 330.411L210.957 325.897L252.5 273.89L232.096 191.071L136.922 198.284L97.7307 247.347L120.792 330.411Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M132.325 314.957L203.581 311.72L236.196 270.889L219.709 205.563L144.505 210.909L113.736 249.428L132.325 314.957Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M143.314 300.945L196.391 298.07L220.989 267.276L209.218 218.441L153.184 222.921L129.978 251.971L143.314 300.945Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M153.708 286.307L144.962 256.079L160.996 236.006L196.668 232.527L204.916 264.736L189.789 283.673L153.708 286.307Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M165.139 272.55L161.421 258.421L169.074 248.841L185.642 246.882L189.107 261.946L181.888 270.984L165.139 272.55Z" stroke="#1CABBF" strokeWidth="2" strokeLinejoin="round" />
  </>
})`
  right: -25.85%;
  bottom: -29%;
  transform: rotate(-3deg) scale(.8);
  transform-origin: center;

  @media screen and (min-width: ${layout.subLg}) {
    display: block;
    right: -6.85%;
    bottom: -37%;
    transform: rotate(-3deg);
  }
`
